import { useState } from 'react';
import axios from 'axios';

import ApiEndpoints from '../const/ApiEndpoints';

const totalPageCount = 'x-total-count';

const useLogs = () => {
  const [accessLogsList, setAccessLogsList] = useState([]);
  const [accessLogsPageCount, setAccessLogsPageCount] = useState(0);
  const [totalAccessLogsCount, setTotalAccessLogsCount] = useState(0);
  const [auditLogsList, setAuditLogsList] = useState([]);
  const [auditLogsPageCount, setAuditLogsPageCount] = useState(0);
  const [totalAuditLogsCount, setTotalAuditLogsCount] = useState(0);

  const fetchAccessLogs = (
    pageIndex = 0,
    pageSize = 10,
    searchText = '',
    startDate = '',
    endDate = '',
    selectedProduct,
    sortField,
    sortOrder,
    tenantId
  ) =>
    axios
      .get(`${ApiEndpoints.BASE_URL + ApiEndpoints.GET_ACCESS_LOG}`, {
        headers: {
          'X-Tenant-ID': tenantId || '',
        },
        params: {
          page_number: pageIndex + 1, // API expects 1-based index
          page_size: pageSize,
          ...(searchText && { text: searchText }),
          ...(startDate && { start_date: startDate }),
          ...(endDate && { end_date: endDate }),
          ...(sortField && { sort_field: sortField }),
          ...(sortOrder && { sort_order: sortOrder }),
          ...(selectedProduct && { product: selectedProduct }),
        },
      })
      .then((res) => {
        if (res.data) {
          setAccessLogsList(res.data);
          setTotalAccessLogsCount(res.headers[totalPageCount]);
          setAccessLogsPageCount(
            Math.ceil(res.headers[totalPageCount] / pageSize)
          );
        } else {
          setAccessLogsList([]);
          setTotalAccessLogsCount(0);
          setAccessLogsPageCount(0);
        }
        return res;
      });

  /**
   * @function fetchUserStats
   * @description API call for fetching user statistics.
   * @returns {Promise<any>} Axios promise containing the response with user statistics.
   * @example fetchUserStats()
   */
  const fetchUserStats = (tenantId) =>
    axios
      .get(`${ApiEndpoints.BASE_URL + ApiEndpoints.GET_USER_STATS}`, {
        headers: {
          'x-tenant-id': tenantId || '',
        },
      })
      .then(
        (res) => res,
        (error) => {
          throw error;
        }
      );

  const DownloadLogs = (tenantId, parameters) =>
    axios
      .get(`${ApiEndpoints.BASE_URL + ApiEndpoints.DOWNLOAD_LOG}`, {
        params: parameters,
        headers: {
          'x-tenant-id': tenantId || '',
        },
      })
      .then(
        (res) => res,
        (error) => {
          throw error;
        }
      );

  const fetchAuditLogs = (
    orgName,
    pageIndex = 0,
    pageSize = 10,
    searchText = '',
    startDate = '',
    endDate = '',
    sortField,
    sortOrder
  ) =>
    axios
      .get(`${ApiEndpoints.BASE_URL + ApiEndpoints.GET_AUDIT_LOG}`, {
        params: {
          page_number: pageIndex + 1,
          page_size: pageSize,
          ...(searchText && { text: searchText }),
          ...(startDate && { start_date: startDate }),
          ...(endDate && { end_date: endDate }),
          ...(sortField && { sort_field: sortField }),
          ...(sortOrder && { sort_order: sortOrder }),
        },
        headers: {
          'x-Tenant-id': orgName || '',
        },
      })
      .then((res) => {
        if (res.data) {
          setAuditLogsList(res.data);
          setTotalAuditLogsCount(res.headers[totalPageCount]);
          setAuditLogsPageCount(
            Math.ceil(res.headers[totalPageCount] / pageSize)
          );
        } else {
          setAuditLogsList([]);
          setTotalAuditLogsCount(0);
          setAuditLogsPageCount(0);
        }
        return res;
      });

  return {
    fetchAccessLogs,
    accessLogsList,
    fetchUserStats,
    accessLogsPageCount,
    totalAccessLogsCount,
    fetchAuditLogs,
    auditLogsList,
    auditLogsPageCount,
    totalAuditLogsCount,
    DownloadLogs,
  };
};

export default useLogs;
